import { acceptHMRUpdate, defineStore } from 'pinia';

// import { getUrlBoolean, getUrlInt, getUrlString } from '@/helpers/UrlParam';

export const useDebugStore = defineStore('debug', () => {
    const enabled = ref(true);
    const stats = ref(false);

    const update = function () {
        if (import.meta.client) {
            enabled.value = getUrlBoolean('debug', true);
            stats.value = getUrlBoolean('stats');
        }
    };

    return {
        enabled,
        stats,

        update,
    };
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(useDebugStore, import.meta.hot));
